import React from 'react';

const NftRequiredComponent = ({ name, img, alt }) => {
  return (
    <div className='nft-required-item'>
      <img src={img} alt={alt}/>
      <p>{name}</p>
    </div>
  );
};

export default NftRequiredComponent;